'use strict';
var app = require('angular').module('dashboard');

app.controller('dashboardTaskCtrl', ['$state', 'departments', 'dialog', 'Department', 'task', '$translate', require('./dashboardTaskCtrl')]);
app.directive('task', [require('./dashboardTaskDirective')]);
app.directive('payload', [require('./payloadDirective')]);
app.config(['$stateProvider', require('./dashboardTaskConfig')]);
